document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const steps = document.querySelectorAll("#process #process-nav li");
  const panes = document.querySelectorAll("#process .process-content");

  let lastPane = -1;

  const setActive = (idx) => {
    const isForward = lastPane === -1 ? true : idx > lastPane;
    lastPane = idx;

    steps.forEach(el => el.classList.remove("active"));
    steps[idx]?.classList.add("active");

    const next = panes[idx];
    panes.forEach(el => el.classList.remove("active"));
    next?.classList.add("active");
    if (!next) return;

    if (idx === 0) return;

    const items = next.querySelectorAll(".process-copy, h3, p, li");

    if (!isForward) {
      gsap.killTweensOf(items);
      gsap.set(items, { clearProps: "all", autoAlpha: 1, y: 0 });
      return;
    }

    gsap.killTweensOf(items);
    gsap.set(items, { y: 10, autoAlpha: 0 });
    gsap.to(items, {
      y: 0,
      autoAlpha: 1,
      duration: 0.45,
      ease: "power1.out",
      stagger: 0.08
    });
  };

  setActive(0);

  steps.forEach((li, i) => {
    li.addEventListener("click", () => setActive(i));
  });
});
